import { Types } from "./viftoActions";
import _ from "lodash";

const integrationReducers = (state, action) => {
    switch (action.type) {
        case Types.VIFTO_CONNECTED: {

            let newState = _.cloneDeep(state);

            const { expenseSettings } = (action.response) || {}

            if (expenseSettings) {
                delete action.response.expenseSettings
                newState.integration.accounting = {
                    ...newState?.integration?.accounting,
                    vifto: {
                        ...newState.integration?.accounting?.vifto,
                        settings: { expenseSettings }
                    }
                }
            }

            newState.integration.accounting = {
                ...newState.integration.accounting,
                vifto: {
                    ...newState.integration?.accounting?.vifto,
                    ...action.response
                }
            }

            return newState;
        }
        case Types.VIFTO_SAVING: {

            let newState = _.cloneDeep(state);

            newState.integration.accounting.vifto.saving = action.status ? action.status : undefined;

            return newState;
        }

        default:
            return state;
    }
};

export default integrationReducers;